import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  body16MainStyles,
  smallcapsRegular11Styles,
} from "@constants/typography"
import { MobileOnly, TabletAndDesktopOnly } from "@utils/MediaQuery"
import React from "react"
import styled from "styled-components"

const Tooltip = styled.div`
  z-index: 99999999;
  position: absolute;
  top: 40px;
  left: 50%;
  display: none;
  box-sizing: border-box;
  transform: translate(-50%, 0);
  width: max-content;
  max-width: 335px;
  margin-top: 1px;
  padding: 1px 20px;
  border-radius: 2px;
  background-color: ${colors.offBlack};
  color: ${colors.offWhite};

  > p {
    ${body16MainStyles}
    margin: 1rem;
    text-align: center;
    color: ${colors.offWhite};
  }
`

export const Container = styled.div<{ backgroundColor?: string }>`
  align-items: center;
  position: relative;
  display: flex;
  height: 24px;
  padding: 0 8px;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? `#${backgroundColor}` : colors.offBlack};

  @media ${breakpoints.laptop} {
    &:hover > ${Tooltip} {
      display: block;
    }
  }

  > ${Tooltip} i {
    position: absolute;
    bottom: 100%;
    left: 50%;
    width: 24px;
    height: 12px;
    margin-left: -12px;
    overflow: hidden;
    &:after {
      content: "";
      position: absolute;
      left: 50%;
      transform: translate(-50%, 50%) rotate(45deg);
      width: 12px;
      height: 12px;
      background-color: ${colors.offBlack};
    }
  }
`

const Text = styled.div<{ color?: string }>`
  ${smallcapsRegular11Styles}
  padding-top: 2px;
  color: ${({ color }) => (color ? `#${color}` : colors.offWhite)};
`

const IconWrapper = styled.div`
  ${ImageHelperContainer} {
    width: 16px;
    height: 12px;

    img {
      object-fit: contain;
    }
  }
`

const Spacer = styled.div`
  width: 6px;
`

export interface ProductTagProps {
  backgroundColor?: string
  color?: string
  hoverText?: string
  icon?: string
  iconRight?: boolean
  mobileText?: string
  text: string
}

const ProductTag: React.FC<ProductTagProps> = ({
  backgroundColor,
  color,
  hoverText,
  icon,
  iconRight,
  mobileText,
  text,
}) => {
  const RenderedIcon = icon ? (
    <IconWrapper>
      <ImageHelper src={icon} />
    </IconWrapper>
  ) : null
  return (
    <Container backgroundColor={backgroundColor}>
      {hoverText && (
        <Tooltip role="tooltip">
          <p>{hoverText}</p>
          <i />
        </Tooltip>
      )}
      {icon && !iconRight && (
        <>
          {RenderedIcon}
          <Spacer />
        </>
      )}
      <MobileOnly>
        <Text color={color}>{mobileText || text}</Text>
      </MobileOnly>
      <TabletAndDesktopOnly>
        <Text color={color}>{text}</Text>
      </TabletAndDesktopOnly>
      {icon && iconRight && (
        <>
          <Spacer />
          {RenderedIcon}
        </>
      )}
    </Container>
  )
}

export default ProductTag
